import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import Tag from "components/base/Tag";
import { useModals } from "ModalProvider";
import EditTagView from "./EditTagView";
import { CLEAR_CATEGORY_TAGS, FETCH_TAG_CATEGORIES } from "./graphql";

const CategoryTagsView = ({ category }) => {
  const modal = useModals();
  const [clearTags, clearTagsRes] = useMutation(CLEAR_CATEGORY_TAGS, {
    refetchQueries: [{ query: FETCH_TAG_CATEGORIES }],
  });

  function createTagHandler(category) {
    modal.present({
      title: "Create New Tag",
      subtitle: `Category: ${category.name}`,
      center: true,
      maxWidth: "max-w-xl",
      children: <EditTagView category={category} hide={modal.hide} />,
    });
  }

  function editHandler(tag) {
    modal.present({
      title: "Edit Tag",
      subtitle: `Tag: ${tag.value}`,
      center: true,
      maxWidth: "max-w-xl",
      children: (
        <EditTagView
          id={tag.id}
          hide={modal.hide}
          initialValues={{ value: tag.value }}
        />
      ),
    });
  }

  function clearTagsHandler() {
    if (category.tags.length === 0) return;

    const confirmed = window.confirm(
      `Are you sure you want to clear all tags in "${category.name}"?`,
    );
    if (!confirmed) return;

    clearTags({
      variables: { categoryId: category.id },
    }).catch((error) => {
      window.alert(parseError(error));
    });
  }

  return (
    <div className="flex justify-between items-center px-4">
      <div className="flex flex-wrap items-center gap-2">
        {category.tags.map((tag) => (
          <Tag
            key={tag.id}
            value={tag.value}
            onClick={() => editHandler(tag)}
          />
        ))}

        <Button onClick={() => createTagHandler(category)}>+ New Tag</Button>
      </div>

      {category.tags.length > 0 && (
        <Button
          danger
          onClick={clearTagsHandler}
          loading={clearTagsRes.loading}
        >
          Clear
        </Button>
      )}
    </div>
  );
};

export default CategoryTagsView;
